import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight, Calculator, Users, TrendingUp, Sparkles } from 'lucide-react';
import { mockData } from '../../data/mock';
import { Reveal } from './Reveal';

export const ServicesBento = () => {
  const services = mockData.services;
  const flagship = services.find((s) => s.specialty) || services[3];
  const expertise = services.find((s) => s.id === 1);
  const social = services.find((s) => s.id === 2);
  const conseil = services.find((s) => s.id === 3);

  return (
    <section className="section-spacing bg-cream">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <Reveal className="max-w-3xl mb-12">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-warm-accent mb-4">Nos expertises</p>
          <h1 className="font-heading text-4xl md:text-6xl font-light tracking-tighter leading-[1.05] text-primary-blue mb-6">
            Le conseil <span className="text-warm-accent">au-delà</span> des chiffres.
          </h1>
          <p className="text-lg md:text-xl text-text-gray leading-relaxed">
            Comptabilité, fiscalité, paie, stratégie de rémunération et accompagnement sur-mesure. Nous déchargeons les dirigeants du chronophage pour les aider à décider et à grandir.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {/* Flagship */}
          <Reveal className="md:col-span-8 md:row-span-2">
            <Link
              to="/services"
              data-testid="service-card-flagship"
              className="bento-card group relative block h-full rounded-3xl bg-primary-blue text-white p-8 md:p-12 overflow-hidden hover:shadow-2xl"
            >
              <Sparkles className="absolute -bottom-10 -right-10 w-56 h-56 text-white/5 group-hover:text-warm-accent/10 transition-colors duration-500" />
              <p className="text-xs uppercase tracking-[0.25em] font-semibold text-warm-accent mb-6">Mission spécialisée</p>
              <h3 className="font-heading text-3xl md:text-5xl font-light leading-tight mb-5">{flagship.titre}</h3>
              <p className="text-white/70 text-lg leading-relaxed max-w-lg mb-8">{flagship.description}</p>
              <ul className="space-y-3 mb-10 max-w-md">
                {(flagship.benefits || []).slice(0, 3).map((b) => (
                  <li key={b} className="flex items-start gap-3 text-white/80">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-warm-accent flex-shrink-0" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
              <span className="inline-flex items-center gap-2 font-medium text-warm-accent">
                Découvrir cette mission
                <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </span>
            </Link>
          </Reveal>

          {/* Expertise */}
          <Reveal className="md:col-span-4" delay={80}>
            <Link
              to="/services"
              data-testid="service-card-expertise"
              className="bento-card group block h-full rounded-3xl bg-white border border-border-soft p-8 hover:shadow-xl hover:border-accent-blue"
            >
              <div className="w-12 h-12 rounded-xl bg-light-blue/40 flex items-center justify-center mb-6">
                <Calculator className="w-6 h-6 text-primary-blue" />
              </div>
              <h3 className="font-heading text-xl font-medium text-text-dark mb-3">{expertise.titre}</h3>
              <p className="text-text-gray text-sm leading-relaxed mb-5">{expertise.description}</p>
              <ArrowUpRight className="w-5 h-5 text-warm-accent transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Reveal>

          {/* Social & Paie */}
          <Reveal className="md:col-span-4" delay={140}>
            <Link
              to="/services"
              data-testid="service-card-social"
              className="bento-card group block h-full rounded-3xl bg-white border border-border-soft p-8 hover:shadow-xl hover:border-accent-blue"
            >
              <div className="w-12 h-12 rounded-xl bg-light-blue/40 flex items-center justify-center mb-6">
                <Users className="w-6 h-6 text-primary-blue" />
              </div>
              <h3 className="font-heading text-xl font-medium text-text-dark mb-3">{social.titre}</h3>
              <p className="text-text-gray text-sm leading-relaxed mb-5">{social.description}</p>
              <ArrowUpRight className="w-5 h-5 text-warm-accent transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Reveal>

          {/* Conseil pleine largeur */}
          <Reveal className="md:col-span-12" delay={100}>
            <Link
              to="/services"
              data-testid="service-card-conseil"
              className="bento-card group flex flex-col sm:flex-row sm:items-center gap-6 rounded-3xl bg-light-blue/30 p-8 md:p-10 hover:bg-light-blue/50"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-blue flex items-center justify-center flex-shrink-0">
                <TrendingUp className="w-7 h-7 text-warm-accent" />
              </div>
              <div className="flex-1">
                <h3 className="font-heading text-2xl font-medium text-primary-blue mb-2">{conseil.titre}</h3>
                <p className="text-text-gray leading-relaxed max-w-2xl">{conseil.description}</p>
              </div>
              <span className="inline-flex items-center gap-2 font-medium text-primary-blue whitespace-nowrap">
                En savoir plus
                <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
